/**
 * @generated SignedSource<<3ea0014dde2cd98e818a0d013d0b132a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
export type WorkspaceSignalReceiversSetTopicIdMutation$variables = {
  id: string;
  topicId?: string | null;
};
export type WorkspaceSignalReceiversSetTopicIdMutation$data = {
  readonly signalWorkspace: {
    readonly updateReceiverTopicId: {
      readonly id: string;
      readonly potentialReceiverStores: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"ReceiverStoresSelectorListItem_receiverStore">;
      }>;
      readonly receiverStores: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly topic: {
        readonly id: string;
      } | null;
    };
  };
};
export type WorkspaceSignalReceiversSetTopicIdMutation$rawResponse = {
  readonly signalWorkspace: {
    readonly updateReceiverTopicId: {
      readonly id: string;
      readonly potentialReceiverStores: ReadonlyArray<{
        readonly id: string;
        readonly routedTeams: ReadonlyArray<{
          readonly color: string | null;
          readonly icon: TeamIcon | null;
          readonly id: string;
          readonly isPrivate: boolean;
          readonly name: string;
        } | null> | null;
        readonly store: {
          readonly id: string;
          readonly name: string;
          readonly workspaceBreadcrumbs: ReadonlyArray<string>;
        };
      }>;
      readonly receiverStores: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly topic: {
        readonly id: string;
      } | null;
    };
  };
};
export type WorkspaceSignalReceiversSetTopicIdMutation = {
  rawResponse: WorkspaceSignalReceiversSetTopicIdMutation$rawResponse;
  response: WorkspaceSignalReceiversSetTopicIdMutation$data;
  variables: WorkspaceSignalReceiversSetTopicIdMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "topicId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "topicId",
    "variableName": "topicId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "OrgTopic",
  "kind": "LinkedField",
  "name": "topic",
  "plural": false,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "receiverStores",
  "plural": true,
  "selections": (v4/*: any*/),
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalReceiversSetTopicIdMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "updateReceiverTopicId",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReceiverStore",
                "kind": "LinkedField",
                "name": "potentialReceiverStores",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ReceiverStoresSelectorListItem_receiverStore"
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceSignalReceiversSetTopicIdMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "updateReceiverTopicId",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ReceiverStore",
                "kind": "LinkedField",
                "name": "potentialReceiverStores",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Store",
                    "kind": "LinkedField",
                    "name": "store",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "includeExternalId",
                            "value": true
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "workspaceBreadcrumbs",
                        "storageKey": "workspaceBreadcrumbs(includeExternalId:true)"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "routedTeams",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "color",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "icon",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isPrivate",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "46c7072f359c5d5d7871ef4976004dbf",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalReceiversSetTopicIdMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceSignalReceiversSetTopicIdMutation(\n  $id: ID!\n  $topicId: ID\n) {\n  signalWorkspace(id: $id) {\n    updateReceiverTopicId(topicId: $topicId) {\n      id\n      potentialReceiverStores {\n        ...ReceiverStoresSelectorListItem_receiverStore\n        id\n      }\n      topic {\n        id\n      }\n      receiverStores {\n        id\n      }\n    }\n  }\n}\n\nfragment AHTeamIcon on Team {\n  icon\n}\n\nfragment AHTeamIconCircle on Team {\n  color\n  ...AHTeamIcon\n  isPrivate\n}\n\nfragment OrgStoreWorkspaceBreadcrumbs_store on Store {\n  workspaceBreadcrumbs(includeExternalId: true)\n}\n\nfragment ReceiverStoresSelectorListItem_receiverStore on ReceiverStore {\n  store {\n    ...ReceiverStoresSelectorMain_receiverStore\n    id\n  }\n  routedTeams {\n    ...ReceiverStoresSelectorTeamsIndicator_teams\n    id\n  }\n}\n\nfragment ReceiverStoresSelectorMain_receiverStore on Store {\n  id\n  name\n  ...OrgStoreWorkspaceBreadcrumbs_store\n}\n\nfragment ReceiverStoresSelectorTeamsIndicator_teams on Team {\n  id\n  name\n  ...AHTeamIconCircle\n}\n"
  }
};
})();

(node as any).hash = "847e50ac760934a70d8cdecbedb3c893";

export default node;
